import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';
import { Box, MenuItem } from '@mui/material';
import ReactQuill from 'react-quill';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },

  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    marginTop: 20,
    borderRadius: 25,
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const DocumentEdit = ({ editObj, refresh, setRefresh, closeAddDialog, allCountry }) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');
  const [documentDescription, setDocumentDescription] = useState('');

  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  // const testsubmit = e => {
  //   e.preventDefault();
  //   let codes = [];
  //   editObj.countries.map(item => {
  //     let name = allCountry.filter(it => it.name === item);

  //     codes.push(name[0].code);
  //   });
  //   console.log('all', codes);
  // };

  const handleSubmit = async e => {
    e.preventDefault();

    let codes = [];
    editObj.countries.map(item => {
      let name = allCountry.filter(it => it.name === item);
      codes.push(name[0].code);
    });

    setLoading(true);
    let response;
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    let formData = {
      documentDescription,
      countryDocumentType: editObj.countryDocumentType,
      documentLanguage: editObj.documentLanguage,
      countries: codes,
    };
    try {
      response = await axios({
        url: `/api/v1/private/documents/${id}`,
        method: 'put',
        data: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setRefresh(!refresh);

      closeAddDialog();

      handleSnakbarOpen(response.data.message, 'success');
    } catch (error) {
      console.log('e', error);
      handleSnakbarOpen(error.response.errors.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    setDocumentDescription(editObj.documentDescription);
    setId(editObj.documentId);
    console.log(editObj);
  }, []);

  return (
    <React.Fragment>
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          Country Document Update
        </Typography>
      </div>

      {/* {documentDescription} */}

      <form onSubmit={handleSubmit}>
        <Box>
          <ReactQuill
            style={{ height: '500px', marginBottom: '40px' }}
            theme="snow"
            value={documentDescription}
            onChange={setDocumentDescription}
          />
        </Box>

        <div className={classes.buttonMarginStyle}>
          {/* {loading ? <LinearProgress /> : null} */}

          <Button
            variant="contained"
            className={classes.buttonStyle}
            color="primary"
            disabled={loading}
            fullWidth
            type="submit">
            {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
            Submit
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default DocumentEdit;
